export default function TripItemCancellationMessageService(
    scrollService
) {
    'ngInject';

    Object.assign(this, {
        addCancellationMessage,
        removeMessage,
    });

    const COMPONENT_SELECTOR = '[kt-trip-item-cancellation-message]';

    function addCancellationMessage(cancellation, formData, status) {
        cancellation.cancellationStatus = {
            status,
            formData,
        };
        scrollService.scrollToElement(COMPONENT_SELECTOR);
    }

    function removeMessage(cancellation) {
        cancellation.cancellationStatus = null;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-item-cancellation-message/trip-item-cancellation-message-service.js